/**
 * @desc 月月付鉴权
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** detail */
  detail: number
  /** orderNo */
  orderNo: string
  /** sign */
  sign: string
  /** token */
  token: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/monthPayCheck',
    params,
    method: 'get',
  })
}
